import React, { useState } from 'react';
import { useIntl, FormattedMessage } from '../../util/reactIntl';
import { Heading, IconArrowHead, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const getSelectedOPtions = (config, key) => config?.find(c => c.key === key)
  ?.enumOptions?.map(o => ({ key: o.option, label: o.label }));

const SectionLandscapeWildlife = props => {
  const { publicData, locale, listingFieldConfigs } = props;
  const {
    Herbivoresinthislandscape,
    Carnivoresinthislandscape,
    Largebirdsinthislandscape,
    Fishcrayfishmolluscs
  } = publicData;

  if (!Herbivoresinthislandscape &&
    !Carnivoresinthislandscape &&
    !Largebirdsinthislandscape &&
    !Fishcrayfishmolluscs) {
    return null;
  }

  const intl = useIntl();
  const [showSection, setShowSection] = useState(true);

  const propertyGroupData = [
    {
      title: intl.formatMessage({ id: 'CustomLabel.Herbivoresinthislandscape' }),
      options: getSelectedOPtions(listingFieldConfigs, "Herbivoresinthislandscape"),
      selectedOptions: Herbivoresinthislandscape
    },
    {
      title: intl.formatMessage({ id: 'CustomLabel.Carnivoresinthislandscape' }),
      options: getSelectedOPtions(listingFieldConfigs, "Carnivoresinthislandscape"),
      selectedOptions: Carnivoresinthislandscape
    },
    {
      title: intl.formatMessage({ id: 'CustomLabel.Largebirdsinthislandscape' }),
      options: getSelectedOPtions(listingFieldConfigs, "Largebirdsinthislandscape"),
      selectedOptions: Largebirdsinthislandscape
    },
    {
      title: intl.formatMessage({ id: 'CustomLabel.Fishcrayfishmolluscs' }),
      options: getSelectedOPtions(listingFieldConfigs, "Fishcrayfishmolluscs"),
      selectedOptions: Fishcrayfishmolluscs
    },
  ];

  return (
    <section className={css.section}>
      <Heading as="h2" rootClassName={css.sectionTitle} onClick={() => setShowSection(!showSection)}>
        <div>
          <FormattedMessage id="ListingPage.wildlifeTitle" />
          <span className={css.sectionSubTitle}>
            <FormattedMessage id="ListingPage.wildlifeSubTitle" />
          </span>
        </div>
        <IconArrowHead direction={showSection ? "up" : "down"} />
      </Heading>

      {showSection && propertyGroupData?.map(data => {
        
        if(!data?.selectedOptions?.length) return null;
        
        return (
          <div className={css.propertyGroup} key={data.title}>
            <h3 className={css.propertyGroupTitle}>
              {data.title}
            </h3>
            <PropertyGroup
              key="ListingPage.experienceInvolves"
              id="ListingPage.experienceInvolves"
              options={data.options}
              selectedOptions={data.selectedOptions}
              twoColumns={data.options.length > 5}
              showUnselectedOptions={false}
              useTranslations
              className={css.propertyGroupList}
            />
          </div>
        )
      })}
    </section>
  );
};

export default SectionLandscapeWildlife;
